import { FC, ReactNode } from "react";
import { Skeleton, Stack, Typography } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { resourceDetailsResourceCoverageDataLoadingSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataLoadingSelector";

interface ResourceDetailsCoverageTabMetadataCardProps {
  title: string;
  children: ReactNode;
}

export const ResourceDetailsCoverageTabMetadataCard: FC<
  ResourceDetailsCoverageTabMetadataCardProps
> = ({ children, title }) => {
  const loading = useAppSelector(
    resourceDetailsResourceCoverageDataLoadingSelector,
  );

  return (
    <Stack
      py={1}
      px={1.5}
      border={1}
      flexGrow={1}
      flexBasis="25%"
      borderRadius={2}
      borderColor="grey.300"
    >
      <Typography
        variant="caption"
        fontWeight="medium"
        color="text.secondary"
        whiteSpace="nowrap"
      >
        {title}
      </Typography>

      {loading ? <Skeleton width="100%" /> : children}
    </Stack>
  );
};
